const riot = require('riot');

riot.tag2('atom-lang-inspector', '<div class="button mr10" each="{lang in [&quot;ja&quot;, &quot;en&quot;, &quot;zh&quot;]}" onclick="{app.utils.changeLanguage}">{lang}</div>', '', '', function(opts) {
});